<script setup lang="ts">
import { computed } from 'vue'
import { ToastViewport, type ToastViewportProps } from 'radix-vue'
import { cn } from '@/lib/utils'
import { chatRightInsetPx } from '@/composables/useChatLayout'

const props = defineProps<ToastViewportProps & { class?: string }>()

// Anchor toasts to the editor area: when the co-scientist chat panel is open,
// inset the viewport's right edge so toasts don't overlap the chat input.
const viewportStyle = computed(() =>
  chatRightInsetPx.value > 0 ? { right: `${chatRightInsetPx.value}px` } : undefined
)
</script>

<template>
  <ToastViewport v-bind="props" :style="viewportStyle" :class="cn('fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]', props.class)" />
</template>
